// Ionic & Angular Imports
import {Injectable} from '@angular/core';
import {Http, Headers, RequestOptions} from '@angular/http';
import {Observable} from 'rxjs/observable';
import 'rxjs/add/operator/map';


export interface IActivity {
    id: number;
    title: string;
    details: string;
    complete: boolean;
}

@Injectable()
export class rsActivitySvc 
{ 
    private titleList : string[] = [
        "Layout", "Forming", "Excavation", "Backfill", "Compaction", "Plumbing", 
        "Electrical", "Shotcrete", "Rebar", "Waterproofing", "Coping", "Deck", 
        "Tile", "Mechanical", "Deck Equipment", "Startup", "Commissioning"
    ];

    constructor(
        public http: Http, 
    ) {
        // Class constructor
    }

    getActivityTitlePresets() : string[] {
        return this.titleList;
    }

    getActivities(reportId: number) : Observable<IActivity[]> {
        return Observable.create( observer => {

            this.http.get( 'http://dfr.hydrocon.com/api/v1/report/' + reportId + '/activities', {
                withCredentials: true
            })
            .map(res => res.json().response.activities )
            .subscribe( result => {
                observer.next(result);
            }, err => {
                observer.error(err);
            }, () => {
                observer.complete();
            });
        });
    }

    addActivity( title: string, details: string, complete: boolean, reportId : number ) : Observable<IActivity> {
        return Observable.create( observer => {
            
            let postData = {
                title : title,
                details : details,
                complete: complete
            }

                let body = JSON.stringify(postData);
                let headers = new Headers({
                    'Content-Type' : 'application/json'
                });
                let options = new RequestOptions( { headers: headers, withCredentials: true } );
                this.http.post( 'http://dfr.hydrocon.com/api/v1/report/' + reportId + '/activities', body, options)
                .map( res => res.json().response.activities )
                .subscribe( result => {
                    observer.next(result);
                }, err => {
                    observer.error(err);
                }, () => {
                    observer.complete();
                });
        });
    }

    updateActivity( activityId : number, title: string, details: string, complete: boolean, reportId: number ) : Observable<IActivity> {
        return Observable.create( observer => {

            let patchData = {
                title: title,
                details: details,
                complete: complete
            }

            let body = JSON.stringify(patchData);
            let headers = new Headers({
                'Content-Type' : 'application/json'
            });
            let options = new RequestOptions( { headers: headers, withCredentials: true } );
            this.http.patch( 'http://dfr.hydrocon.com/api/v1/report/' + reportId + '/activities/' + activityId, body, options )
            .map( res => res.json().response.activities )
                .subscribe( result => {
                    observer.next(result);
                }, err => {
                    observer.error(err);
                }, () => {
                    observer.complete();
                });
        });
    }
    
    deleteActivity( activityId : number, reportId : number ) : Observable<void> {
        return Observable.create( observer => {

            this.http.delete( 'http://dfr.hydrocon.com/api/v1/report/' + reportId + '/activities/' + activityId, {
                withCredentials: true 
            })
            .map( res => res.json() )
            .subscribe( result => {
                observer.next( result );
            }, err => {
                observer.error(err);
            }, () => {
                observer.complete();
            });
        });
    }
}


// WEBPACK FOOTER //
// ./src/services/activity.service.ts